{
  "kind": "findings",
  "source": "docs/FINDINGS.md",
  "status": "deployed, measured, and current as of 2026-08-05.",
  "sections": [
    {
      "n": 1,
      "title": "The recommendation"
    },
    {
      "n": 2,
      "title": "Current state, per use case"
    },
    {
      "n": 3,
      "title": "Why each recommendation is the best option"
    },
    {
      "n": 4,
      "title": "Region failure and capacity"
    },
    {
      "n": 5,
      "title": "Test results"
    },
    {
      "n": 6,
      "title": "Open questions and what is unproven"
    }
  ],
  "recommendation": [
    {
      "t": "Build UC1 for serial issuance, unconditionally, with reclamation off. For the rules layer, use Aurora DSQL (UC4). Keep rule resolution off the issuance hot path. Monitor every serial pool's utilisation and alarm on the traffic rate rather than on the mark.",
      "b": true
    }
  ],
  "useCases": [
    {
      "heading": "UC1 — DynamoDB high-water mark plus a shared Valkey buffer",
      "status": [
        {
          "t": "Live in both regions. This is the issuance recommendation and it is not a close call.",
          "b": true
        }
      ]
    },
    {
      "heading": "UC2 — Aurora PostgreSQL rules plus a DynamoDB ledger",
      "status": [
        {
          "t": "Live in both regions. Not recommended for the rules layer, for one reason that cannot be configured away.",
          "b": true
        }
      ]
    },
    {
      "heading": "UC4 — Aurora DSQL rules",
      "status": [
        {
          "t": "Live in both regions, serving ",
          "b": true
        },
        {
          "t": "POST /v4/labels",
          "b": true,
          "c": true
        },
        {
          "t": ", ",
          "b": true
        },
        {
          "t": "GET /v4/rules",
          "b": true,
          "c": true
        },
        {
          "t": ", ",
          "b": true
        },
        {
          "t": "GET /v4/health",
          "b": true,
          "c": true
        },
        {
          "t": " and ",
          "b": true
        },
        {
          "t": "GET /v4/integrity",
          "b": true,
          "c": true
        },
        {
          "t": ". This is the rules-layer recommendation.",
          "b": true
        }
      ]
    },
    {
      "heading": "UC7 — Aurora PostgreSQL Global Database rules",
      "status": [
        {
          "t": "Live in both regions, serving ",
          "b": true
        },
        {
          "t": "POST /v7/labels",
          "b": true,
          "c": true
        },
        {
          "t": ", ",
          "b": true
        },
        {
          "t": "GET /v7/rules",
          "b": true,
          "c": true
        },
        {
          "t": " and ",
          "b": true
        },
        {
          "t": "GET /v7/health",
          "b": true,
          "c": true
        },
        {
          "t": ". Built, deployed, driven through three disruptive events, and NOT recommended — but it is a genuine trade, not a weak option, and two of its advantages over UC4 are real and measured.",
          "b": true
        }
      ]
    },
    {
      "heading": "Reclamation — orthogonal to all four, and the highest-risk mechanism in the project",
      "status": [
        {
          "t": "Current state: fully wired, unit- and integration-tested, deployed, and armed nowhere.",
          "b": true
        },
        {
          "t": " "
        },
        {
          "t": "ENABLE_RECLAMATION=false",
          "c": true
        },
        {
          "t": " on all three functions in both regions."
        }
      ]
    }
  ],
  "unproven": [
    {
      "n": 1,
      "claim": [
        {
          "t": "⚠️ NO SERIAL HAS EVER BEEN RECLAIMED BY THE SWEEP IN A LIVE REGION.",
          "b": true
        }
      ]
    },
    {
      "n": 2,
      "claim": [
        {
          "t": "⚠️ THE CAPACITY HALF OF REGION FAILURE HAS NEVER BEEN MEASURED.",
          "b": true
        },
        {
          "t": " The "
        },
        {
          "t": "routing",
          "b": true
        },
        {
          "t": " half is drilled live and works — traffic moved to the survivor, and a vend through the shared name returned a serial from the survivor's own range, which is structurally incapable of colliding. But "
        },
        {
          "t": "no region has been taken to zero, no survivor has been watched absorbing the other's load for any length of time, and no pool's serial capacity has been tested under a doubled rate.",
          "b": true
        }
      ]
    },
    {
      "n": 3,
      "claim": [
        {
          "t": "⚠️ The buffer's OWN sustained ceiling is still unlocated, because the compute tier bound the ramp first.",
          "b": true
        }
      ]
    },
    {
      "n": 4,
      "claim": [
        {
          "t": "⚠️ R8 — zero outages, not even for patching — HAS NOW BEEN MEASURED FOR UC7, AND IT FAILS THERE. IT REMAINS UNMEASURED FOR UC4 AND UC2, AND FOR UC4 IT IS NOT MEASURABLE FROM OUTSIDE.",
          "b": true
        }
      ]
    },
    {
      "n": 5,
      "claim": [
        {
          "t": "⚠️ UC4 HAS BEEN DRIVEN THROUGH NO DISRUPTIVE EVENT AT ALL",
          "b": true
        },
        {
          "t": " — no patch, no switchover, no failover — while UC7 has been driven through three."
        }
      ]
    },
    {
      "n": 6,
      "claim": [
        {
          "t": "⚠️ Apigee's own contribution — the measurement we cannot make.",
          "b": true
        }
      ]
    },
    {
      "n": 7,
      "claim": [
        {
          "t": "Every failure mode except a regional outage and UC7's own topology events is still uninjected.",
          "b": true
        }
      ]
    },
    {
      "n": 8,
      "claim": [
        {
          "t": "⚠️ UC7's connection ceiling was measured against a limit that was OUR OWN ARTEFACT rather than Aurora's.",
          "b": true
        }
      ]
    },
    {
      "n": 9,
      "claim": [
        {
          "t": "Whether a second reader instance per region would close UC7's patch window.",
          "b": true
        }
      ]
    },
    {
      "n": 10,
      "claim": [
        {
          "t": "Several-thousand-pool scale.",
          "b": true
        }
      ]
    },
    {
      "n": 11,
      "claim": [
        {
          "t": "The per-pool monitoring has never fired an alarm",
          "b": true
        },
        {
          "t": ", and its listing coverage remains a "
        },
        {
          "t": "lower bound",
          "b": true
        },
        {
          "t": " even after the registration fix (§4)."
        }
      ]
    },
    {
      "n": 12,
      "claim": [
        {
          "t": "UC4's commit latency and optimistic-concurrency behaviour under real contention.",
          "b": true
        },
        {
          "t": " Also "
        },
        {
          "t": "UC4's p99 is unexplained",
          "b": true
        },
        {
          "t": " (§5.9), as is the Aurora bimodality."
        }
      ]
    },
    {
      "n": 13,
      "claim": [
        {
          "t": "UC7's operational defects are recorded and NOT fixed",
          "b": true
        },
        {
          "t": " — stale region roles after a switchover, and write forwarding not moving with the roles (§2)."
        }
      ]
    },
    {
      "n": 14,
      "claim": [
        {
          "t": "Zero DAX reads ever succeeded",
          "b": true
        },
        {
          "t": " (§3). Hit rate is "
        },
        {
          "t": "n/a",
          "b": true
        },
        {
          "t": ", not \"good\"."
        }
      ]
    }
  ]
}
